import { blueGrey } from '@material-ui/core/colors';
import { softShadows, strongShadows } from 'src/theme/shadows';
import { TTheme } from 'src/views/account/AccountView/General/types';

export const buildUserTheme = (theme: TTheme, mode: 'dark' | 'light') => {
    const darkMode = {
        action: {
            active: 'rgba(255, 255, 255, 0.54)',
            hover: 'rgba(255, 255, 255, 0.04)',
            selected: 'rgba(255, 255, 255, 0.08)',
            disabled: 'rgba(255, 255, 255, 0.26)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            focus: 'rgba(255, 255, 255, 0.12)',
        },
        palette: {
            background: {
                default: '#2a2d3d',
                dark: '#222831',
                paper: '#2a323d',
            },
        },
        shadows: strongShadows,
    };

    const lightMode = {
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: blueGrey[600],
                    },
                },
            },
        },
        palette: {
            background: {
                default: '#ffffff',
                dark: '#f0edf5',
                paper: '#f9f5ff',
            },
        },
        shadows: softShadows,
    };

    return {
        name: 'CUSTOM_THEME',
        ...(mode === 'dark' ? darkMode : lightMode),
        palette: {
            type: mode,
            ...(mode === 'dark' ? darkMode.palette : lightMode.palette),
            primary: {
                main: theme.primary,
            },
            secondary: {
                main: theme.secondary,
            },
            error: {
                main: theme.error,
            },
            success: {
                main: theme.success,
            },
            warning: {
                main: theme.warning,
            },
            text: {
                primary: theme.textPrimary,
                secondary: theme.textSecondary,
            },
        },
    };
};
